// global
import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
// components
import { Form } from 'semantic-ui-react';
import ComponentWrapper from 'app/components/commons/componentWrapper/ComponentWrapper';
// icons
import DropdownIcon from './Icon';
// utils
import _ from 'lodash';
//stylesheet
import styles from './DefaultDropdown.module.scss';

function DefaultDropdown(props) {
  const {
    condition,
    dependency,
    disabled,
    error,
    groupIndex,
    inline,
    label,
    onChange,
    onOpen,
    onClose,
    options,
    placeholder,
    required,
    searchable,
    size,
    value,
    width,
    loading,
    fullWidth,
    fixedWidth,
    readOnly,
    helperText,
    onSearchChange,
    noFoundMessage,
    ...rest
  } = props;

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleOpen = e => {
    if (e) setDropdownOpen(true);
    if (onOpen) onOpen();
  };

  const handleClose = () => {
    setDropdownOpen(false);
    if (onClose) onClose();
  };

  const handleChange = (e, target) => {
    const { value, options } = target || e.target;
    const optionSelected = options.find(option => option.value === value);
    onChange(value, optionSelected, groupIndex);
    setDropdownOpen(false);
  };

  const showError = () => {
    const { error: err, groupIndexes, repeated } = error;

    const isRepetedQuestion = !!repeated;

    if (isRepetedQuestion) {
      return err && (_.isEmpty(groupIndexes) || groupIndexes.includes(groupIndex)) && !disabled;
    }

    return !!err && !disabled;
  };

  const getStyle = () => {
    const isError = showError();
    const isFilled = !!value;

    let style = styles[size];

    if (isError) {
      style += ` ${styles.error}`;
    } else if (isFilled) {
      style += ` ${styles.filled}`;
    }

    if (fullWidth) style += ` ${styles.fullWidth}`;
    if (fixedWidth) style += ` ${styles.fixedWidth}`;
    if (readOnly) style += ` ${styles.defaultDropdownReadOnly}`;

    return style;
  };

  const getHelperText = () => {
    const sholdShowError = showError();

    if (sholdShowError) return error.error;
    if (helperText) return helperText;

    return '';
  };

  const style = getStyle();

  return (
    <ComponentWrapper {...{ dependency, condition }}>
      <Form.Field width={width}>
        <Form.Dropdown
          {...rest}
          id={styles.defaultDropdown}
          className={style}
          disabled={disabled}
          inline={inline}
          label={label}
          open={dropdownOpen}
          onOpen={handleOpen}
          onClose={handleClose}
          onChange={handleChange}
          options={options}
          placeholder={placeholder}
          required={required}
          search={searchable}
          selection={true}
          value={value}
          upward={false}
          onSearchChange={onSearchChange}
          icon={<DropdownIcon size={size} loading={loading} error={showError()} />}
          noResultsMessage={noFoundMessage}
        ></Form.Dropdown>
        <Form.Field className={styles.helperText}>{getHelperText()}</Form.Field>
      </Form.Field>
    </ComponentWrapper>
  );
}

DefaultDropdown.defaultProps = {
  dependency: null,
  condition: true,
  disabled: false,
  helperText: '',
  error: {
    error: ''
    // groupIndexes: [],
    // repeated: false
  },
  // groupIndex: null,
  inline: false,
  label: '',
  onChange: () => {},
  onOpen: () => {},
  onClose: () => {},
  options: [],
  placeholder: '',
  required: false,
  size: 'medium',
  noFoundMessage: 'Nada encontrado.',
  loading: false,
  fullWidth: false,
  fixedWidth: false
};

DefaultDropdown.propTypes = {
  condition: PropTypes.bool,
  dependency: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  error: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    groupIndexes: PropTypes.array,
    repeated: PropTypes.bool
  }),
  groupIndex: PropTypes.number,
  inline: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onSearchChange: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  noFoundMessage: PropTypes.string,
  required: PropTypes.bool,
  searchable: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'big', 'huge']),
  value: PropTypes.number,
  width: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16]),
  loading: PropTypes.bool,
  fullWidth: PropTypes.bool,
  fixedWidth: PropTypes.bool
};

export default memo(DefaultDropdown);
